/**
 * CardPlanIconContainer component.
 */
import styled from 'styled-components';
import Screen from '@shared/utils/screen';

/**
 * Styled wrapper for the card plan icon.
 */
const CardPlanIconContainer = styled.div<{ focused?: boolean }>`
  padding-right: ${(props) => (props?.focused ? 6 * Screen.widthRatio : 0)}px;
`;

export default CardPlanIconContainer;
